import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { parseISO, isSameDay, differenceInCalendarDays, isValid, format } from 'date-fns';

@Pipe({
  name: 'scheduleDate',
  standalone: true,
})
export class ScheduleDatePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | Date | null): string {
    if (!value) {
      return '';
    }

    try {
      const scheduledDate = parseISO(value as string);
      const now = new Date();

      if (!isValid(scheduledDate)) {
        return 'Błędna data';
      }

      if (scheduledDate.getTime() <= now.getTime()) {
        return this.translate.instant('filesStatus.connectingToVehicle');
      }

      if (isSameDay(scheduledDate, now)) {
        const timeString = format(scheduledDate, 'HH:mm');
        return `${this.translate.instant('filesStatus.scheduledToday')} ${timeString}`;
      }

      const dayDiff = differenceInCalendarDays(scheduledDate, now);

      if (dayDiff > 0) {
        const unit = (dayDiff === 1) ? this.translate.instant('date-time.day') : this.translate.instant('days');
        return `${this.translate.instant('filesStatus.scheduledFor')} ${dayDiff} ${unit}`;
      } else {
        return '--';
      }
    }
    catch (error) {
      return 'Błąd formatowania';
    }
  }
}
